<script lang="ts">
	export let active = false;
</script>

{#if active}
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="26"
		height="26"
		viewBox="0 0 26 26"
		fill="none"
	>
		<path
			d="M13 0C5.824 0 0 5.8188 0 13C0 20.1812 5.824 26 13 26C20.176 26 26 20.176 26 13C26 5.824 20.1812 0 13 0ZM20.202 8.2212L11.7936 18.4392C11.6948 18.5588 11.5492 18.6264 11.3932 18.6264C11.2372 18.6264 11.0916 18.5588 10.9928 18.4392L5.798 12.1264C5.616 11.908 5.64719 11.5804 5.87079 11.3984C6.09439 11.2164 6.41679 11.2476 6.60399 11.466L11.3932 17.29L19.4012 7.5608C19.5832 7.3372 19.9108 7.306 20.1344 7.488C20.3528 7.67 20.3892 7.9976 20.202 8.2212Z"
			fill="#6591FA"
		/>
	</svg>
{:else}
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="26"
		height="26"
		viewBox="0 0 26 26"
		fill="none"
	>
		<path
			d="M13 0C5.824 0 0 5.8188 0 13C0 20.1812 5.824 26 13 26C20.176 26 26 20.176 26 13C26 5.824 20.1812 0 13 0ZM13 24.96C6.4064 24.96 1.04 19.5936 1.04 13C1.04 6.4064 6.4064 1.04 13 1.04C19.5936 1.04 24.96 6.4064 24.96 13C24.96 19.5936 19.5988 24.96 13 24.96Z"
			fill="#BCBFC3"
		/>
		<path
			d="M11.3932 18.6264C11.2372 18.6264 11.0916 18.5588 10.9928 18.4392L5.80318 12.1264C5.62118 11.9028 5.65239 11.5752 5.87599 11.3932C6.09959 11.2112 6.42719 11.2424 6.60919 11.466L11.3984 17.29L19.4064 7.56081C19.5884 7.33721 19.916 7.30601 20.1396 7.48801C20.3632 7.67001 20.3944 7.9976 20.2124 8.2212L11.804 18.4392C11.7052 18.5588 11.5596 18.6264 11.4036 18.6264"
			fill="#BCBFC3"
		/>
	</svg>
{/if}
